import React, { useState, useEffect, useContext } from 'react';
import { UserContext } from '../context/UserContext';
import { callAPI } from '../helper/apiHelper';
import { API_URL_ENDPOINT, BASE_URL } from '../appsetting/appsetting';
import CButton from './CButton';

const PointTracker = () => {
  const { globalUser } = useContext(UserContext);
  const [oneMinutePoint, setOneMinutePoint] = useState(2);

  // State to keep track of the points
  const [minute, setMinute] = useState(0);

  useEffect(() => {
    getOneMinutePoint()
    // Set an interval to increment points every 1 minute (60,000 ms)
    const interval = setInterval(() => {
      setMinute((prevMinute) => prevMinute + 1);
    }, 60000);

    return () => clearInterval(interval);
  }, []);

  const getOneMinutePoint = async () => {
    try{
        const response = await callAPI(BASE_URL + API_URL_ENDPOINT.GET_REWARD_DATA);
        if(response?.data && response?.status){
          const oneminutepoint = response?.data?.find(item => item.Type === "LiveWatch")?.Point || 0;
          setOneMinutePoint(oneminutepoint)
        }else{
          throw new Error(response?.message || "No Request Found")
        }
      }catch(error){
        setOneMinutePoint(2)
      }finally{
      }
  }

  // Update Points to Database
  useEffect(() => {
    if (minute > 0 && globalUser) {
      UpdateMinuteToDatabase(minute);
    }
  }, [minute]);

  const UpdateMinuteToDatabase = async (updatedMinute) => {
    try {
      const options = {
        method: 'POST',
        data: {
          userId: globalUser?.ID,
          minutes: updatedMinute,
        },
      }
      await callAPI(BASE_URL+API_URL_ENDPOINT.UPDATE_USER_MINUTE, options)
    } catch (error) {
      console.error('Error updating Minutes:', error);
    }
  };

  return (
    <div>
      <div>
        <i className="bi bi-award-fill"></i> {minute * oneMinutePoint} 
      </div>
      {/* <div style={{ fontSize: 12 }} className="fw-bold text-warning">
        Point : {minute * oneMinutePoint}
      </div> */}
      {/* <div style={{ fontSize: 8 }} className="text-white text-end">
        1 Min. = {oneMinutePoint} Point
      </div> */}
    </div>
  );
};

export default PointTracker;
